const SHOPIFY_DOMAIN = process.env.REACT_APP_SHOPIFY_STORE_DOMAIN;
const STOREFRONT_TOKEN = process.env.REACT_APP_SHOPIFY_STOREFRONT_TOKEN;
const API_VERSION = process.env.REACT_APP_SHOPIFY_API_VERSION;

async function shopifyCustomerFetch(query, variables = {}) {
  const response = await fetch(
    `https://${SHOPIFY_DOMAIN}/api/${API_VERSION}/graphql.json`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({
        query,
        variables
      })
    }
  );

  const json = await response.json();

  if (json.errors) {
    throw new Error(json.errors[0]?.message || 'Erro na Shopify');
  }

  return json.data;
}

export async function registerCustomer({ nome, email, senha }) {
  const query = `
    mutation customerCreate($input: CustomerCreateInput!) {
      customerCreate(input: $input) {
        customer {
          id
          firstName
          email
        }
        customerUserErrors {
          field
          message
          code
        }
      }
    }
  `;

  const variables = {
    input: {
      firstName: nome,
      email,
      password: senha
    }
  };

  const data = await shopifyCustomerFetch(query, variables);
  return data.customerCreate;
}

export async function loginCustomer({ email, senha }) {
  const query = `
    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
      customerAccessTokenCreate(input: $input) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          field
          message
          code
        }
      }
    }
  `;

  const variables = {
    input: {
      email,
      password: senha
    }
  };

  const data = await shopifyCustomerFetch(query, variables);
  return data.customerAccessTokenCreate;
}

export async function getCurrentCustomer(accessToken) {
  const query = `
    query customer($customerAccessToken: String!) {
      customer(customerAccessToken: $customerAccessToken) {
        id
        firstName
        lastName
        email
      }
    }
  `;

  const variables = {
    customerAccessToken: accessToken
  };

  const data = await shopifyCustomerFetch(query, variables);
  return data.customer;
}

export function saveCustomerSession(customerAccessToken) {
  localStorage.setItem('customerAccessToken', customerAccessToken.accessToken);
  localStorage.setItem('customerAccessTokenExpiresAt', customerAccessToken.expiresAt);
}

export function getSavedCustomerToken() {
  return localStorage.getItem('customerAccessToken');
}

export function clearCustomerSession() {
  localStorage.removeItem('customerAccessToken');
  localStorage.removeItem('customerAccessTokenExpiresAt');
}
export async function getCustomerProfile(accessToken) {
  const query = `
    query customerProfile($customerAccessToken: String!) {
      customer(customerAccessToken: $customerAccessToken) {
        id
        firstName
        lastName
        email
        phone
        displayName
        numberOfOrders
        defaultAddress {
          address1
          address2
          city
          province
          zip
          country
        }
      }
    }
  `;

  const variables = {
    customerAccessToken: accessToken
  };

  const data = await shopifyCustomerFetch(query, variables);
  return data.customer;
}

export async function getCustomerOrders(accessToken) {
  const query = `
    query customerOrders($customerAccessToken: String!) {
      customer(customerAccessToken: $customerAccessToken) {
        orders(first: 20, reverse: true) {
          edges {
            node {
              id
              orderNumber
              processedAt
              fulfillmentStatus
              financialStatus
              totalPrice {
                amount
                currencyCode
              }
              lineItems(first: 10) {
                edges {
                  node {
                    title
                    quantity
                    originalTotalPrice {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const variables = {
    customerAccessToken: accessToken
  };

  const data = await shopifyCustomerFetch(query, variables);
  return data.customer?.orders?.edges || [];
}